export class PostBody {
  ContractorNumber: string;
  Language: string;
  ProductionNumber:string;
  Id: Number;
  PrintLabelCount: Number;
  AnswerRequired:boolean;
 }